<template lang="pug">
  v-dialog(v-model="show", v-if="estabelecimentos && estabelecimentos.length", width="50%", max-height="70%")
    v-card.br-10
      v-card-title.title Compartilhe no WhatsApp
      v-card
        v-card-text
          v-layout(row, wrap)
            v-flex.md12
              v-list(three-line)
                template(v-for='(estabelecimento, i) in estabelecimentos')
                  v-list-tile
                    v-list-tile-content
                      v-list-tile-title.content-text {{ estabelecimento.nome }}
                      v-list-tile-sub-title.content-text {{estabelecimento.localidade}} - {{estabelecimento.estado}}
                        br
                        BadgeOrigem(:cardapio_digital="estabelecimento.cardapio_digital ? true : false", :label="true")
                    v-list-tile-action
                      v-btn.br-4(slot="activator", @click="compartilharWhatsApp(estabelecimento)", color="success")
                        v-icon.fa.fa-whatsapp.ml-2
                        span.ml-2.mr-2 Compartilhar
                  v-divider(v-if="i < estabelecimentos.length - 1")
        v-card-actions
          v-spacer
          v-btn(@click="close()", flat) Fechar

</template>

<script>
import _ from "lodash";
import BadgeOrigem from "@/components/BadgeOrigem";

export default {
  components: {
    BadgeOrigem
  },
  props: {
  },
  data () {
    return {
        show : false,
        loading: false,
        estabelecimento: null
    }
  },
  created () {
  },
  mounted() {

  },
  watch: {
  },
  computed: {
    estabelecimentos(){
      return _.sortBy(this.$root.estabelecimentos, 'nome')
    },
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    }
  },
  methods: {
    open(){
      this.show = true;
      this.estabelecimento = this.estabelecimentoSelecionado ? _.cloneDeep(this.estabelecimentoSelecionado) : null;
    },
    close(){
      this.show = false;
    },
    compartilharWhatsApp (estabelecimento) {
      console.log('compartilharWhatsApp', this.$root.getURL(estabelecimento));
      window.open(`whatsapp://send?text=${this.$root.getURL(estabelecimento)}`);
    },
  }
}
</script>

<style lang="scss" scoped>
.content-text{
  white-space: normal;
  word-wrap: break-word;
  height: auto;
}
</style>
